// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l8TlY","content":"styles_content__2aikh","row":"styles_row__Cp-vk","footer":"styles_footer__1cL97","phraseLength":"styles_phraseLength__1na3B"};